export default __webpack_public_path__ + "static/media/naidi-2.04766fff.svg";